import { useCallback, useEffect } from "react"
import { useDispatch } from "react-redux"
import client from "../../api/client"
import { loadGame, receiveGame } from "./gameSlice"

export default function useGame(id: string) {
    const dispatch = useDispatch()
    const onGameUpdate = useCallback((game) => dispatch(receiveGame({ game })), [dispatch])
    useEffect(() => {
        dispatch(loadGame(id))
        const unsubscribe = client.subscribe(id, onGameUpdate)
        return () => unsubscribe()
    }, [id, dispatch, onGameUpdate])
}